export const MODULE_NAME = 'lk-notification-pages'


export const LK_NOTIFICATION_PAGES_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  VIEW_ONCE: `${MODULE_NAME}.view-once`,
} as const
